import '@ant-design/v5-patch-for-react-19';

import { Page, Spinner } from '@honestica/ui-kit/src';
import { getAuthenticationError } from '@store/user/user.selector';
import { useSelector } from 'react-redux';

import { Apps } from './components/Apps';
import { ErrorPage } from './components/ErrorPage';
import { useIsAppLoading } from './hooks/useIsAppLoading.hook';

export const App = () => {
  const isLoading = useIsAppLoading();
  const authenticationError = useSelector(getAuthenticationError);

  const renderSpinner = () => (
    <Page.Empty>
      <Spinner />
    </Page.Empty>
  );

  if (authenticationError) {
    return <ErrorPage errorKey={authenticationError} />;
  }

  return (
    <>
      {isLoading ? (
        renderSpinner()
      ) : (
        <>
          <Apps />
        </>
      )}
    </>
  );
};
